export const initialState = {
  notes: [],
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'report_exceptions_get_exception_notes_success':
      return {
        ...state,
        notes: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || [],
      }
    default:
      return state
  }
}
